/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { DecimalFieldDisplay } from "./display";
import { DecimalFieldEdit } from "./edit";

const DecimalField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <DecimalFieldDisplay />,
        editComponent: <DecimalFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
DecimalField.displayName = "DecimalField";
export { DecimalField };
